import { useEffect, useState } from "react";
import { ChatListSidebar } from "../components/chat-list.sidebar";
import { ChatContent } from "../components/chat-content";
import { ChatChart } from "../components/chat-chart";
import { ChatMessage } from "@racoon/api";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@racoon/ui";
import { useChatHistoryQuery } from "~/shared/api/chat/chat.api";

export const ChatPage = () => {
  const [activeChatId, setActiveChatId] = useState<string | null>(null);
  const [selectedMessage, setSelectedMessage] = useState<ChatMessage | null>(null);

  const { data: messages } = useChatHistoryQuery(activeChatId as string, {
    skip: !activeChatId,
  });

  const handleChangeChartIndex = (type: "prev" | "next") => {
    const history = messages?.history.filter((msg) => msg.role === "assistant") || [];
    const currentIndex = history.findIndex((msg) => msg.id === selectedMessage?.id);
    if (currentIndex === -1) return;
    const newIndex = type === "prev" ? currentIndex - 1 : currentIndex + 1;
    setSelectedMessage(history[newIndex] || null);
  };

  useEffect(() => {
    if (activeChatId && messages?.history) {
      const lastAssistantMsg =
        [...messages.history].reverse().find((msg) => msg.role === "assistant") || null;
      setSelectedMessage(lastAssistantMsg);
    }
  }, [activeChatId, messages?.history]);

  return (
    <ResizablePanelGroup
      direction="horizontal"
      className="h-full w-full bg-white dark:bg-slate-950 rounded-xl flex flex-1 p-4 gap-4"
    >
      <ResizablePanel defaultSize={20} className="h-full" minSize={16}>
        <ChatListSidebar activeChatId={activeChatId} setActiveChatId={setActiveChatId} />
      </ResizablePanel>
      <ResizableHandle />
      <ResizablePanel className="h-full flex flex-1" minSize={40}>
        <ChatContent
          chatId={activeChatId}
          setActiveChatId={setActiveChatId}
          selectedMessage={selectedMessage}
          onMessageSelect={setSelectedMessage}
        />
      </ResizablePanel>
      <ResizableHandle />
      <ResizablePanel minSize={16}>
        <ChatChart
          messageIndex={messages?.history
            .filter((msg) => msg.role === "assistant")
            .findIndex((msg) => msg.id === selectedMessage?.id)}
          message={selectedMessage}
          onChangeChartIndex={handleChangeChartIndex}
        />
      </ResizablePanel>
    </ResizablePanelGroup>
  );
};
